import '@src/assets/style/main.scss'
import EndlessList from '@src/component/endlessList'
import {formatString} from '@src/constant'
import {isEmpty} from '@src/util'
import {Picker, Toast} from 'antd-mobile-v2'
import moment from 'moment'
import React from 'react'

const GuaranteeStatus = [
    {value: "0", label: '待担保人提交'},
    {value: "1", label: '待审核'},
    {value: "2", label: '需修改资料'},
    {value: "3", label: '需更换担保人'},
    {value: "88", label: '已过期'},
]

export type QueryResultType = { list: Array<any>; total: number }

export type QueryType = {
    page: number
    content?: string
    status?: number
    guaranteeApplyStatus: number
}

type GuaranteeApplicationPropsType = {
    action?: (params: QueryType) => QueryResultType | Promise<QueryResultType>
    hide?: boolean
}

type GuaranteeApplicationStateType = {
    page: number
    list: any[]
    total: number
    params: {
        content: string
        status?: number
        date?: any
        guaranteeComposeStatus: number
    }
    loading?: boolean
}

export default class guaranteeApplication extends React.Component<GuaranteeApplicationPropsType,
    GuaranteeApplicationStateType> {
    ref?: any
    containerRef?: any
    datePickerRef?: any

    constructor(props: GuaranteeApplicationPropsType) {
        super(props)
        this.state = {
            page: 0,
            list: [],
            total: 0,
            params: {
                content: '',
                guaranteeComposeStatus: -1,
            },
        }
    }

    async onRefresh(state?: GuaranteeApplicationStateType) {
        const {list, total, page, params} = state || this.state
        if (total && list.length >= total) {
            return
        }
        const newPage = page + 1
        const param: any = {
            ...params,
            pages: newPage,
        }
        if (isEmpty(param.content)) {
            delete param.content
        }
        const {action} = this.props
        if (!action || typeof action !== 'function') {
            return
        }
        this.setState({loading: true})
        let data = action(param)
        if (data instanceof Promise) {
            data = await data
        }
        this.setState({loading: false})
        if (data) {
            let _list: any[] = data.list || []
            const _total = data.total || 0
            _list = list.concat(_list)
            this.setState({total: _total, list: _list, page: newPage})
        } else {
            Toast.fail('数据加载失败...')
        }
    }

    componentDidMount() {
        this.onRefresh()
    }

    UNSAFE_componentWillReceiveProps(nextProps: GuaranteeApplicationPropsType) {
        if (nextProps.hide !== this.props.hide && nextProps.hide === false) {
            const {params} = this.state
            const state = {params, page: 0, list: [], total: 0}
            this.setState(state)
            this.onRefresh(state)
            this.containerRef?.querySelector('div').scrollTo({top: 0})
        }
    }

    filterItemChange(type: 'status' | 'guaranteeApplyStatus', value: any) {
        const {params} = this.state
        if (type === 'status') {
            params.status = value
        } else if (type === 'guaranteeApplyStatus') {
            params.guaranteeComposeStatus = value
        }

        const state = {params, page: 0, list: [], total: 0}
        this.setState(state)
        this.onRefresh(state)
        this.containerRef?.querySelector('div').scrollTo({top: 0})
    }

    allStatus(array: Array<{ label: string; value: any }>) {
        return [{value: -1, label: '全部'}].concat(array)
    }

    statusText(array: Array<{ label: string; value: any }>, status: any) {
        return array.find((e) => e.value == status)?.label || '全部'
    }

    render() {
        const {
            list,
            params,
            loading,
            total,
        } = this.state
        const {hide} = this.props
        const noMore = list.length >= total

        return (
            <>
                <div className="m-tab" style={{display: hide ? 'none' : 'flex'}}>
                    <div className="m-query-bar">
                        {/* 手机号 */}
                        <div className="m-row">
                            <input
                                className="input"
                                value={params.content}
                                placeholder="请输入姓名/手机号搜索"
                                onChange={(e) => {
                                    const value = e.target.value
                                    if (isEmpty(value)) {
                                        params.content = ''
                                    } else {
                                        params.content = value
                                    }
                                    this.setState({params})
                                }}
                            />
                            <div
                                className="btn-search"
                                onClick={() => {
                                    const params = this.state.params
                                    const state = {params, page: 0, list: [], total: 0}
                                    this.onRefresh(state)
                                }}
                            >
                                搜索
                            </div>
                        </div>
                        {/* 分类选择 */}
                        <div className="m-row">
                            <div className="m-filter-item">
                                <span className="btn-selector-label">状态:</span>
                                <Picker
                                    data={this.allStatus(GuaranteeStatus)}
                                    value={
                                        params.guaranteeComposeStatus || params.guaranteeComposeStatus === 0
                                            ? [params.guaranteeComposeStatus]
                                            : undefined
                                    }
                                    extra="全部"
                                    cols={1}
                                    onChange={(e) => {
                                        let statusValue: any
                                        if (e && e.length > 0) {
                                            const value: any = e[0]
                                            statusValue = value
                                        } else {
                                            statusValue = undefined
                                        }
                                        this.filterItemChange('guaranteeApplyStatus', statusValue)
                                    }}
                                >
                  <span className="btn-selector-value">
                    {this.statusText(GuaranteeStatus, params.guaranteeComposeStatus)}
                  </span>
                                </Picker>
                            </div>
                        </div>
                    </div>
                    {/* list body */}
                    <div className="m-body" ref={this.containerRef}>
                        <EndlessList
                            onTouchBottom={this.onRefresh.bind(this)}
                            loading={loading}
                            noMore={noMore}
                        >
                            <div className="m-list">
                                {list.map((e, i) => <RenderItem data={e} key={i}/>)}
                            </div>
                        </EndlessList>
                    </div>
                </div>
            </>
        )
    }
}

export function RenderItem(props: { data: any }) {
    const {data} = props

    return (
        <div className="m-list-item">
            <div className="row">
                <div className="label name">{data.insuredName}</div>
                <div className="value">{data.mobile}</div>
            </div>
            <div className="row">
                <div className="label" style={{whiteSpace: 'nowrap'}}>
                    复审通过时间
                </div>
                <div className="value">
                    {data.loanPassTime && moment(data.loanPassTime).format(formatString)}
                </div>
            </div>
            <div className="row">
                <div className="label">申请车型</div>
                <div className="value">
                    {data.brandName}+{data.vehicleName}
                </div>
            </div>
            <div className="row">
                <div className="label">跟单销售</div>
                <div className="value">{data.saleName}</div>
            </div>
            <div className="row">
                <div className="label">担保人</div>
                <div className="value">{data.guaranteeName || '-'}</div>
            </div>
            <div className="row">
                <div className="label">担保人电话</div>
                <div className="value">{data.guaranteeMobile || '-'}</div>
            </div>
            <div className="row">
                <div className="label">状态</div>
                <div
                    className='value'>{GuaranteeStatus.filter(status => parseInt(status.value) === data.guaranteeApplyStatus)[0]?.label}</div>
            </div>
            {data.uptime && (
                <div className="row">
                    <div className="label">更新时间</div>
                    <div className="value">
                        {moment(data.uptime).format(formatString)}
                    </div>
                </div>
            )}
        </div>
    )
}
